export const required = value => (value ? undefined : 'Required');
export const requiredAtLeaseOne = value => (value.length != 0 ? undefined : 'At lease one');
